import { useAuth } from "contexts/useAuth";

type ValidateUserPermissionsParams = {
    abilities?: any;
    permissions?: string[];
    // role?: '';
}

export function ValidateUserPermissions({ permissions }: ValidateUserPermissionsParams) {

    const { profile } = useAuth()

    const { abilities } = profile

    if (abilities?.includes("*")) return true

    if (permissions && permissions?.length > 0) {

        const hasAllPermissions = permissions?.every(permission => {
            return abilities?.includes(permission)
        })

        if (!hasAllPermissions) return false

    }

    return true

}